export const referralLeadsApiFormDataKeysToStateKeysMapping = {
  fullName: 'fullName',
  email: 'email',
  phoneNumber: 'phoneNumber',
  gstNumber: 'gstNumber',
  saleAmount: 'quotedPrice',
};
